import React from "react"

import ProductSwiper from "./ProductSwiper"
import URLs from "../helpers/urls"

import styles from "./pdpymal.module.scss"
import { graphql, useStaticQuery } from "gatsby"


const PdpYMAL = ({ products }) => {

  let components = []

  const data = useStaticQuery(graphql`
      query YMALQuery {
          allProductStyle(filter: {handle: {in: [
              "frontline-105-nappa",
              "fellini-haircalf-pumps",
              "easy-rider-short",
              "icon-105mm-nappa",
              "kiss-vitello"]}}) {
              nodes {
                  ...RecStyleFragment
              }
          }
      }
  `)

  // Filter out products that don't have YMAL images
  const filteredProducts = products.filter(product => product.images.ymal)

  // If there are less than 5 products for the module, add filler products
  if (filteredProducts.length < 5)
    data.allProductStyle.nodes.slice(0,5-filteredProducts.length).forEach(product => {
      filteredProducts.push(product)
    })

  filteredProducts.forEach(product => {
    components.push({
      __typename: "ContentfulProductTile",
      name: product.title.split(" - ")[0],
      productId: product.product_id,
      url: `/${URLs.productUrlPrefix}/${product.handle}`,
      price: product.skus[0].variants[0].price.toString(),
      badge: null,
      color: null,
      image: product.images.ymal.replace(/(\.jpg)/i, "_640x.progressive$1"),
    })
  })

  const ymalData = {
    componentName: "You May Also Like",
    slug: "you-may-also-like",
    heading: {
      heading: "You May Also Like",
      textSize: "heading-2",
      textAlignment: "center",
    },
    components: components,
    initCarousel: true,
    navigation: components.length > 5,
    pagination: false,
    layout: "Product Grid",
    hidePricing: false,
    internal: {
      type: "ContentfulMultipleComponents",
    },
    id: "",
    rebuildOnUpdate: true,
    loop: components.length > 5,
  }

  return (
    <ProductSwiper
      data={ymalData}
      customStyles={styles}
      origin="ymal"
    />
  )
}

export default PdpYMAL
